import { render, staticRenderFns } from "./RequirementValues.vue?vue&type=template&id=252eebd2&"
import script from "./RequirementValues.vue?vue&type=script&lang=js&"
export * from "./RequirementValues.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports